import React, { useState, useCallback } from "react";
import { faHeart, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import "./Favorites.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { product_reviews } from "../Redux/API";
import no_fav from '../images/no_fav.svg'
import { searsh_product } from "../Redux/HomeSlice";
import Loader from "../Loader";
import Searsh from '../Searsh/Searsh'
import { show_brand, show_Influencer, show_store} from '../Redux/API';
import {

  product_details,
  favorites,
  remove_favorites
} from "../Redux/API";

function Favorites() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const gotoProductDetails = (product) => {
    localStorage.setItem("Product_id", product.id);
    dispatch(product_details(product.id));
    dispatch(product_reviews(product.id));
    window.scrollTo(0, 0);
    navigate("/Product");
    dispatch(searsh_product(false));


    const id = product?.type?.id;
    if (!id || !product?.vendor_type) return;

    switch (product.vendor_type) {
      case "brand":
          localStorage.setItem('brandId', id);
          dispatch(show_brand({ id }));
          break;
      case "influencer":
          localStorage.setItem('InfluencerId', id);
          dispatch(show_Influencer({ id }));
          break;
      case "store":
          localStorage.setItem('storeId', id);
          dispatch(show_store({ id }));
          break;
      default:
          console.error("Unknown vendor type:", product.vendor_type);
    }
  };

  const gotoHome = () => {
    navigate("/");
    window.scrollTo(0, 0);
  };

  const loadingRemove_favorites = useSelector((state) => state.Data.loadingRemove_favorites);

  useEffect(() => {
    if (!loadingRemove_favorites) {
      dispatch(favorites());
    }
  }, [dispatch, loadingRemove_favorites]);

  const favorite = useSelector((state) => state?.Data.favorites);
  const handelremove_wishlist = (id) => {
    dispatch(remove_favorites(id));
  };
  const show_searsh = useSelector((state) => state?.products?.searsh);
  const images = favorite?.data?.data || [];

  return (
    <div className="offers">
      <Header />

      {show_searsh && (
        <Searsh />
      )}

      <div className="container">
        <div className="cont row justify-content-between g-0 p-0">
          <h3 className="title">{t("favorites")}</h3>
          <div className="wishlist col border-0">
            <div className="gallery1 container ">
              {loadingRemove_favorites && <Loader />}
              <div className="row_prodect row  align-items-center justify-content-around  p-0 g-0 border-0">
              {images.length == 0  && 
                  <div className="empty-cart">
                    <img src={no_fav} alt="Empty Cart" />
                  </div>
              }
                {favorite?.data?.data?.length === 0 ? (
                  <>
                  <div className="empty-favorites text-center">
                    <p>{t("Your favorites list is empty!")}</p>
                    <button className="btn btn-primary" onClick={gotoHome}>
                      {t("Add Products to Favorites")}
                    </button>
                  </div>
                  </>
                ) : (
                  <div className="row_prodect row align-items-center justify-content-around p-0 g-0 border-0">
                    {favorite?.data?.data?.map(
                      (product, index) => (
                        <div
                          key={index}
                          className="box col-5 col-sm-4 px-sm-2 col-md-4 px-md-3 col-lg-3 px-lg-3 mx-lg-0 col-xl-2 mx-xl-1 px-xl-0 text-center g-0 mb-3"
                        >
                          <div className="border_box">
                              <div className="padding_box">
                              <i>
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  onClick={() =>
                                    handelremove_wishlist(product.product_id)
                                  }
                                />
                              </i>
                              {product?.discount && (
                                <p className="discount">
                                  {t("Off")} {product?.discount}
                                </p>
                              )}
                              {product.main_image && (
                                <img
                                  src={product?.main_image}
                                  alt={`img-${index}`}
                                  onClick={() => gotoProductDetails(product.id)}
                                />
                              )}
                              <p className="discraptoin"  onClick={() => gotoProductDetails(product.id)}>
                                {product?.product_description}
                              </p>
                              <div className="price align-items-center"  onClick={() => gotoProductDetails(product.id)}>
                                <p>{product?.new_price}</p>
                                {product?.old_price && (
                                  <p className="old_price">
                                    {product?.old_price}
                                  </p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default Favorites;
